import { supabase } from "./supabaseClient";

const MAX_IMAGE_BYTES = 12 * 1024 * 1024;
const ALLOWED_TYPES = new Set(["image/jpeg", "image/png", "image/webp", "image/heic", "image/heif"]);

export const validateReviewImage = file => {
  if (!file) return "Selecciona una imagen.";
  if (!ALLOWED_TYPES.has(file.type)) return "Formato no compatible. Usa JPG, PNG, WEBP o HEIC.";
  if (!file.size || file.size > MAX_IMAGE_BYTES) return "La imagen debe pesar 12 MB o menos.";
  return null;
};

export const uploadReviewImage = async file => {
  const validation = validateReviewImage(file);
  if (validation) throw new Error(validation);
  const body = new FormData();
  body.append("file", file, file.name || "review-image.jpg");
  const { data, error } = await supabase.functions.invoke("upload-review-image", { body });
  if (error) throw error;
  if (!data?.ok || !data?.image?.url) throw new Error(data?.error || "No se pudo procesar la imagen.");
  return {
    ...data.image,
    name: file.name || "",
    privacy: {
      ...(data.image.privacy || {}),
      faces_blurred: data.image?.privacy?.faces_blurred !== false,
      reversible: Boolean(data.image?.moderation?.mode === "dual" || data.image?.privacy?.reversible),
    },
  };
};
